import httpService from "./httpService";
import { Extraction } from "../utils/types";

export const createExtraction = async (params: Extraction) => httpService.post(`/extractions`, params);

export const search = async (params?: any) => {
	const { data } = await httpService.get(`/extractions/search`, { params });
	return data;
};

export const updateExtraction = async (extraction: any) => httpService.put(`/extractions/${extraction.id}`, extraction);

export const getExtraction = async (id) => {
	const { data } = await httpService.get(`/extractions/${id}`);
	return data;
};

export const deleteExtraction = async (id: string | number) => {
	const { data } = await httpService.delete(`/extractions/${id}`);
	return data;
};
